.purchase {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: stretch;
  gap: 8px;
  padding: 0 16px;
}

.purchaseError {
  min-height: 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  margin: 10px 0;
}

.purchaseMessage {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
}

.purchaseInput {
  flex: 1;
  min-width: 0;
  border-radius: 8px;
  background-color: var(--ib-blush);
}

.purchaseInputText {
  text-align: right;
}

.lotsInput {
  width: 5.5rem;
  flex: none;
}

.purchase .button {
  flex: none;
  width: auto;
  margin: 0;
  padding: 0 22px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.errorText {
  height: 5%;
}

@media (max-width: 550px) {
  .purchaseMessage {
    height: fit-content;
    width: 100%;
    padding: 0.4rem 0.5rem;
  }
}
